@if (showPrompt()) {
  <div class="mobile-prompt-overlay">
    <div class="mobile-prompt-card">
      <div class="mobile-prompt-image">
        <img
          src="/assets/media/svg/smartphone.svg"
          alt="Download the NSSF Go mobile app"
        />
      </div>
      <p class="mobile-prompt-text">
        Maximize your experience with our dedicated mobile app! Enjoy faster
        access, exclusive features, and notifications right at your fingertips.
      </p>
      <button class="mobile-prompt-download" (click)="downloadApp()">
        Download App
      </button>
      <button class="mobile-prompt-continue" (click)="continueOnWeb()">
        Continue on Web
        <i class="ki-duotone ki-arrow-right fs-3">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </button>
    </div>
  </div>
}
